import {InputLabel, Stack, styled, Typography} from '@mui/material'

export const Label = styled(InputLabel)(({theme}) => ({
  textAlign: 'start',
  color: theme.palette.grey[100],
  ...theme.typography.body2,
}))

export const OuterWrapper = styled(Stack)(() => ({
  alignItems: 'flex-start',
  gap: '0.5rem',
}))

export const InnerWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  gap: '1rem',
}))

export const StyledText = styled(Typography)(() => ({
  textAlign: 'start',
  fontWeight: 'bold',
}))
